import React from 'react';
import { Box, Typography, IconButton, Skeleton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import type { CommunityMessageLinkPreview } from '../../services/communityService';

interface Props {
  preview: CommunityMessageLinkPreview | null;
  loading?: boolean;
  onDismiss?: () => void;
}

export const LinkPreviewDraft: React.FC<Props> = ({ preview, loading, onDismiss }) => {
  if (!loading && !preview) return null;

  return (
    <Box
      sx={{
        mx: 1.25,
        mb: 0.5,
        bgcolor: '#fff',
        borderRadius: 1.5,
        border: '1px solid #e9edef',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      {onDismiss && (
        <IconButton
          size="small"
          onClick={onDismiss}
          sx={{ position: 'absolute', top: 4, right: 4, zIndex: 1, bgcolor: 'rgba(255,255,255,0.9)' }}
          aria-label="Dismiss link preview"
        >
          <CloseIcon sx={{ fontSize: 16 }} />
        </IconButton>
      )}

      {loading ? (
        <Box sx={{ p: 1.5 }}>
          <Skeleton variant="text" width="70%" />
          <Skeleton variant="text" width="90%" />
          <Skeleton variant="rectangular" height={80} sx={{ mt: 1, borderRadius: 1 }} />
        </Box>
      ) : preview ? (
        <Box sx={{ display: 'flex', flexDirection: preview.image_url ? 'column' : 'row', gap: 1, p: 1.25 }}>
          {preview.image_url && (
            <Box
              component="img"
              src={preview.image_url}
              alt=""
              sx={{ width: '100%', maxHeight: 120, objectFit: 'cover', borderRadius: 1 }}
            />
          )}
          <Box sx={{ flex: 1, minWidth: 0, pr: onDismiss ? 3 : 0 }}>
            <Typography sx={{ fontSize: '0.72rem', color: '#8696a0', textTransform: 'uppercase' }}>
              {preview.site_name || new URL(preview.url).hostname}
            </Typography>
            {preview.title && (
              <Typography
                sx={{
                  fontSize: '0.85rem',
                  fontWeight: 600,
                  color: '#111b21',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {preview.title}
              </Typography>
            )}
            {preview.description && (
              <Typography
                sx={{
                  fontSize: '0.78rem',
                  color: '#667781',
                  overflow: 'hidden',
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                }}
              >
                {preview.description}
              </Typography>
            )}
          </Box>
        </Box>
      ) : null}
    </Box>
  );
};
